import { notification } from 'antd';
import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';
import constants from 'utils/constants';
import { ApiContext } from 'utils/networking/Api.context';
import hbxConstants from '../../../hbxConstants.js';

export default function useInvoiceAPIConfigHook(pmsNotPermit) {
  const {
    appState,
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isLoading: false,
    dateSelected: null,
    bookingProvider: null,
    pmsNotPermit: null,
  });

  useEffect(() => {
    updateState({ pmsNotPermit: pmsNotPermit });
  }, []);

  const actions = {
    onSaveFTPConfig: async () => {
      try {
        updateState({ isLoading: true });
        const hotelData = await API.getOneHotel({ hotelId: getSelectedHotel()?.key });

        if (!state.pmsNotPermit) {
          await API.saveInvoiceSFTP(getSelectedHotel()?.key, hotelData.atlasId, 'active', {
            provider: constants.BOOKING_PROVIDER.API,
            ftpConfig: {
              host: null,
              user: null,
              password: null,
              port: null,
            },
            fileFormat: null,
            filePrefix: null,
            fileSufix: null,
            ftpDirPath: null,
          });

          notification.success({
            message: translate('policeReport.saveConfigSuccess'),
          });
        } else {
          notification.warning({
            message: translate('hbxProducts.pmsInvalidCongif.title').replace(
              '%s',
              state.pmsNotPermit
            ),
            description: translate('hbxProducts.pmsInvalidCongif.description').replace(
              '%s',
              hbxConstants.AUTOINV_PMS_PERMIT_TEXT
            ),
          });
        }

        updateState({ isLoading: false });
      } catch (err) {
        updateState({ isLoading: false });
        notification.error({
          message: translate('policeReport.saveConfigError'),
        });
      }
    },

    isAdmin: () => appState?.superUser ?? false,
  };

  function updateState(object) {
    setState(prev => ({ ...prev, ...object }));
  }

  return { state, actions };
}
